/**
 * @generated SignedSource<<f27ffa32d7ee2f64e2240308fd5f9ec7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelCheckShopifyTestStoreQuery$variables = {
  salesChannelID?: number | null;
};
export type salesChannelCheckShopifyTestStoreQuery$data = {
  readonly shopifyAuthEcommerceSettings: {
    readonly isTestStore: boolean;
  } | null;
};
export type salesChannelCheckShopifyTestStoreQuery = {
  response: salesChannelCheckShopifyTestStoreQuery$data;
  variables: salesChannelCheckShopifyTestStoreQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "salesChannelID",
        "variableName": "salesChannelID"
      }
    ],
    "concreteType": "ShopifyAuthEcommerceSettings",
    "kind": "LinkedField",
    "name": "shopifyAuthEcommerceSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isTestStore",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelCheckShopifyTestStoreQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelCheckShopifyTestStoreQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "c2be1f8b5059f04eace594aa4d58ce77",
    "id": null,
    "metadata": {},
    "name": "salesChannelCheckShopifyTestStoreQuery",
    "operationKind": "query",
    "text": "query salesChannelCheckShopifyTestStoreQuery(\n  $salesChannelID: Long\n) {\n  shopifyAuthEcommerceSettings(salesChannelID: $salesChannelID) {\n    isTestStore\n  }\n}\n"
  }
};
})();

(node as any).hash = "aefc1682063f7f09d2ebd9f768f2415e";

export default node;
